import { triggerEvent } from '../utilities/utilities';
import pubsub from '../pubsub/pubsub';

/**
 * Autosubmit
 * A plugin that adds autosubmit functionality..
 * @version 3.0.0
 * @exports AutoSubmit
 */
export default class AutoSubmit {
	/**
	 * Constructor
	 * @public
	 */
	constructor() {
		this._initAutosubmit();
		this._initSubscriptions();
	}

	/**
	 * Function that initiates the autosubmit functionality.
	 * This can be used on an input to have it to submit the form on change.
	 * @private
	 */
	_initAutosubmit() {
		const els = document.querySelectorAll('[data-type="autosubmit"]');

		els.forEach(el => {
			if (el.getAttribute('data-initiated') !== null) {
				return false;
			}

			el.setAttribute('data-initiated', true);

			el.addEventListener('change', () => {
				let form = el.form;

				if (form !== null) {
					if (form.getAttribute('data-type') === 'ajaxForm') {
						pubsub.publish('/ajaxForm/load');
					} else {
						triggerEvent(form, 'submit');
					}
				}
			});
		});
	}

	/**
	 * Initiates subscriptions.
	 * @private
	 */
	_initSubscriptions() {
		pubsub.subscribe('/ajaxForm/sync/updated', this._initAutosubmit);
	}
}
